/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The DeviceTokensResponse model module.
 * @module model/DeviceTokensResponse
 * @version 0.0.1
 */
class DeviceTokensResponse {
    /**
     * Constructs a new <code>DeviceTokensResponse</code>.
     * @alias module:model/DeviceTokensResponse
     */
    constructor() { 
        
        DeviceTokensResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>DeviceTokensResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DeviceTokensResponse} obj Optional instance to populate.
     * @return {module:model/DeviceTokensResponse} The populated <code>DeviceTokensResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DeviceTokensResponse();

            if (data.hasOwnProperty('tokens')) {
                obj['tokens'] = ApiClient.convertToType(data['tokens'], [Object]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>DeviceTokensResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>DeviceTokensResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is an array
        if (!Array.isArray(data['tokens'])) {
            throw new Error("Expected the field `tokens` to be an array in the JSON data but got " + data['tokens']);
        }

        return true;
    }


}



/**
 * @member {Array.<Object>} tokens
 */
DeviceTokensResponse.prototype['tokens'] = undefined;






export default DeviceTokensResponse;

